import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=c3dcbc66&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3dcbc66')) {
      api.createRecord('c3dcbc66', component.options)
    } else {
      api.reload('c3dcbc66', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=c3dcbc66&", function () {
      api.rerender('c3dcbc66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8x8HNaOJ4XDDR/JS/comp/offershelp.vue"
export default component.exports